import { GetExpenseResponse, PutExpenseType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useUpdateExpense = createTripMutation<
    GetExpenseResponse,
    { tripId: string; expenseId: number; expenseData: PutExpenseType }
>({
    mutationFn: async ({ tripId, expenseId, expenseData }) => {
        const response = await api.patch<GetExpenseResponse>(`/trips/${tripId}/expenses/${expenseId}`, expenseData)
        return response.data
    },
    invalidate: ({ tripId }) => [queryKeys.expenses(tripId), queryKeys.paymentsOwed(tripId)],
})
